import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

export function formatDateTime(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
}

// Short relative time — "just now", "2h ago", "3 days ago"
export function formatRelativeTime(isoString) {
    if (!isoString) return '';
    const then = new Date(isoString).getTime();
    if (Number.isNaN(then)) return '';
    const diffMs = Date.now() - then;
    if (diffMs < 60_000) return 'just now';
    const mins = Math.floor(diffMs / 60_000);
    if (mins < 60) return `${mins} min${mins !== 1 ? 's' : ''} ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} day${days !== 1 ? 's' : ''} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months !== 1 ? 's' : ''} ago`;
    const years = Math.floor(days / 365);
    return `${years} year${years !== 1 ? 's' : ''} ago`;
}

// Oldest (max-age) pending-since timestamp among a list of orders
export function oldestPendingSince(orders) {
    const times = orders
        .map(o => o.artwork_pending_since)
        .filter(Boolean)
        .map(s => new Date(s).getTime())
        .filter(n => !Number.isNaN(n));
    if (times.length === 0) return null;
    return new Date(Math.min(...times)).toISOString();
}

export function getStatusClass(status) {
    const statusMap = {
        'Quote': 'status-quote',
        'Quoted': 'status-quoted',
        'Draft': 'status-draft',
        'awaiting_payment': 'status-submitted',
        'Paid': 'status-completed',
        'Submitted': 'status-submitted',
        'In Progress': 'status-in-progress',
        'On Hold': 'status-on-hold',
        'Shipping': 'status-shipping',
        'Delivered/Closed': 'status-completed',
        'Completed': 'status-completed',
        'Cancelled': 'status-cancelled',
    };
    return statusMap[status] || 'status-draft';
}

export function getPurchaseStatusClass(status) {
    const statusMap = {
        'Planned': 'purchase-planned',
        'Ordered': 'purchase-ordered',
        'Invoiced': 'purchase-invoiced',
        'Paid': 'purchase-paid',
    };
    return statusMap[status] || 'purchase-planned';
}

export function truncateText(text, maxLength = 50) {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}
